import React, {useEffect, useRef, useState} from "react";
import './userDetails.css'
import userPhoto from '../../../assets/download.png'
import axios from "axios";
import {useParams} from "react-router";
const apiUrl = process.env.REACT_APP_API;
function UserDetails() {
    const MyEnum = {
        0: 'Սպասվում է',
        1: 'Մասնակցած',
        2: 'Մերժված'
    }

    let {userId: userId} = useParams();
    const [code, setCode] = useState();
    const [blockReason, setBlockReason] = useState('')
    const [state, setState] = useState({})
    let btns = useRef(null)
    let reasonInput = useRef(null)

    useEffect(() => {
        getConfirmCode().then(res => {
            let generateCode = res * 12 - 48 / 3 + 94 * 31;
            setCode(res)
            getUserDetails(generateCode).then(res => {
                setState(res)

            })
            if (state.arrive === 1 || state.arrive === 2) {
                btns.current.style.display = "none";
                reasonInput.current.style.display = "none";
            }
        });
        if (state.arrive === 1 || state.arrive === 2) {
            btns.current.style.display = "none";
            reasonInput.current.style.display = "none";
        }
    }, [])
    if (state.arrive === 1 || state.arrive === 2) {
        btns.current.style.display = "none";
        reasonInput.current.style.display = "none";
    }

    const getConfirmCode = async () => {
        let res = await axios.get(`${apiUrl}/user/getconfirmcode`)
        let {data} = res;
        return data;
    }

    const getUserDetails = async (generateCode) => {
        let res = await axios.get(`${apiUrl}/user/getuserbyid/${userId}/${generateCode}`);
        let {data} = res;
        return data;

    }

    function forDelete() {
        getConfirmCode().then(res => {
            let generateCode = res * 12 - 48 / 3 + 94 * 31;
            setCode(res)
            arriveHandlerDelete(generateCode).then(res => {
                setState(res)
            });
        });
        setTimeout(() => {
            window.location.reload()

        }, 1000)
    }

    function forApprove() {
        getConfirmCode().then(res => {
            let generateCode = res * 12 - 48 / 3 + 94 * 31;
            setCode(res)
            arriveHandlerApprove(generateCode).then(res => {
                setState(res)
            });
        });
        setTimeout(() => {
            window.location.reload()

        }, 1000)
    }

    const arriveHandlerDelete = async (generateCode) => {
        let res = await axios.post(`${apiUrl}/user/updateuser/${generateCode}`, {
            userId: userId,
            arrive: 2,
            blockReason: blockReason,
        });
        let {data} = res;
        return data;
    }

    const arriveHandlerApprove = async (generateCode) => {
        let res = await axios.post(`${apiUrl}/user/updateuser/${generateCode}`, {
            userId: userId,
            arrive: 1,
            blockReason: ''
        });
        let {data} = res;
        return data;
    }
    return (

        <div className='user-details-block'>
            <div className='user-pic-info-block'>
                <div className="photo-block">
                    <img src={userPhoto} alt=""/>
                </div>
                <div className="info-block">
                    <div className="info-cols-block">
                        <span>Անուն</span>
                        <span className='info-cols'> {state.firstName}</span>
                    </div>
                    <div className="info-cols-block">
                        <span>Ազգանուն</span>
                        <span className='info-cols'> {state.lastName}</span>
                    </div>
                    <div className="info-cols-block">
                        <span>Բոնուս Քարտ</span>
                        <span className='info-cols'>  {state.bonusCard}</span>
                    </div>
                    <div className="info-cols-block">
                        <span>Հասցե</span>
                        <span className='info-cols'>  {state.address}</span>
                    </div>
                    <div className="info-cols-block">
                        <span>Հեռ․ համար</span>
                        <span className='info-cols'>  {state.phoneNumber}</span>
                    </div>
                    <div className="info-cols-block">
                        <span>Էլ․ հասցե</span>
                        <span className='info-cols'>  {state.email}</span>
                    </div>
                    <div className={state.blockReason === ''?'d_none':'info-cols-block'}>
                        <span>Մերժման պատճառը</span>
                        <span className='info-cols'> {state.blockReason ? state.blockReason : 'blocked reason'} </span>
                    </div>
                    <div className="info-cols-block">
                        <span>Ստատուս</span>
                        <span className='info-cols'>
                            {
                                state.arrive === 0 && <span className="pending"> {MyEnum["0"]}</span> ||
                                state.arrive === 1 && <span className="active"> {MyEnum["1"]}</span> ||
                                state.arrive === 2 && <span className="decline"> {MyEnum["2"]}</span>
                            }
                    </span>
                    </div>
                    <div className={state.approvedDate === null ? 'd_none ':'info-cols-block'}>
                        <span>Այցի օր</span>
                        <span className={'info-cols'}> {state.approvedDate ? state.approvedDate.split('T')[0] : ''} </span>
                    </div>

                    <input ref={reasonInput} value={blockReason} onChange={e => setBlockReason(e.target.value)}
                           className='info-cols' placeholder='Մերժելու պատճառը'/>
                </div>
                <div className="info-btns-block" ref={btns}>
                    <button className="forDelete" onClick={forDelete}>Մերժել</button>
                    <button className="forApprove" onClick={forApprove}>Հաստատել</button>
                </div>
            </div>
        </div>
    );
}

export default UserDetails;
